export interface CampaignDrawerOpen {
    groupId: string | number;
    cardIndex: number;
    cardData?: CampaignDrawerCardData;
    cardCssOrder?: number;
    hasHash: boolean;
    sourceId?: string;
}

interface CampaignDrawerCardData {
    id?: string;
    close?: string;
    detailData?: any;
    linkId?: string;
    media?: any;
    subtitle?: string;
    title?: string;
    topLink?: string;
    viewLessSubtitle?: string;
    viewLessTitle?: string;
    viewMoreSubtitle?: string;
    viewMoreTitle?: string;
}

export const DEFAULT_DRAWER_STATE = {
    groupId: -1,
    cardIndex: -1,
    hasHash: false
};
